import React, { useEffect, useState } from "react";
import {
  ChakraProvider,
  Box,
  Text,
  Grid,
  IconButton,
  HStack,
  Stack,
} from "@chakra-ui/react";
import { AiFillFacebook, AiOutlineInstagram } from "react-icons/ai";
import { FaPinterest } from "react-icons/fa";
import theme from "./theme";
import { CalculateCountdown } from "./Helper/CalculateCountdown";

export const App = () => {
  const launchingDay = new Date("2024-05-12");
  const [countdown, setCountdown] = useState(CalculateCountdown(launchingDay));
  const urlBg = process.env.PUBLIC_URL + "/images/bg-stars.svg";
  const urlMountain = process.env.PUBLIC_URL + "/images/pattern-hills.svg";

  useEffect(() => {
    const timerId = setInterval(() => {
      setCountdown(CalculateCountdown(launchingDay));
    }, 1000);
    return () => clearInterval(timerId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ChakraProvider theme={theme}>
      <Box bgImage={`url(${urlBg})`} bgColor={"#201E2B"}>
        <Grid p={3} minH="80vh">
          <Stack justifyContent={"center"} alignItems={"center"}>
            <Text mb="50px" fontWeight={"700"}>
              WE'RE LAUNCHING SOON
            </Text>
            <HStack spacing="24px">
              {["DAYS", "HOURS", "MINUTES", "SECONDS"].map((item, index) => {
                let value;
                if (item === "DAYS") value = countdown.days;
                if (item === "HOURS") value = countdown.hours;
                if (item === "MINUTES") value = countdown.minutes;
                if (item === "SECONDS") value = countdown.seconds;

                return (
                  <Stack gap={0} alignItems={"center"} key={index}>
                    <Box
                      w={{ base: "70px", sm: "100px" }}
                      h={{ base: "35px", sm: "50px" }}
                      bgColor={"#2C2C44"}
                      borderRadius={10}
                      m="0"
                    />
                    <Box
                      m="0"
                      w={{ base: "70px", sm: "100px" }}
                      h={{ base: "35px", sm: "50px" }}
                      bgColor={"#34364F"}
                      borderRadius={10}
                      boxShadow="dark-lg"
                    />
                    <Stack position={"absolute"} top="38.5%">
                      <Text
                        color={"#fb6087"}
                        fontWeight={"900"}
                        fontSize={{ base: "35px", sm: "40px" }}

                        // bgGradient="linear(to-l, #DA4F70, #fb6087)"
                      >
                        {" "}
                        {value}
                      </Text>
                    </Stack>
                    <Text color={"#8486a9"} mt="20px">
                      {item}
                    </Text>
                  </Stack>
                );
              })}
            </HStack>
          </Stack>
        </Grid>
        <Stack
          justifyContent={"center"}
          minH="20vh"
          bgImage={`url(${urlMountain})`}
          alignItems={"center"}
        >
          <HStack justifyContent={"center"}>
            <IconButton
              _hover={{ color: "#fb6087" }}
              color={"#FFFFFF"}
              aria-label="Facebook icon"
              icon={<AiFillFacebook size={30} />}
              bg={"none"}
            />
            <IconButton
              _hover={{ color: "#fb6087" }}
              aria-label="Pinterest icon"
              icon={<FaPinterest size={30} />}
              color={"#FFFFFF"}
              bg={"none"}
            />
            <IconButton
              _hover={{ color: "#fb6087" }}
              color={"#FFFFFF"}
              aria-label="Instagram icon"
              icon={<AiOutlineInstagram size={30} />}
              bg={"none"}
            />
          </HStack>
        </Stack>
      </Box>
    </ChakraProvider>
  );
};
